/**
 * @param props
 */

export default (props) => {
    return {
        reason: null,
        comment: null,
        loading: false,
        message: null,
        error: false,
        success: false,
        mounted() {

        },
        submit() {
            this.loading = true;
            fetch(this.service.video.report.action,
                {
                    headers: {
                        "Content-Type": "application/json",
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: "POST",
                    body: JSON.stringify({
                        reason:  this.reason,
                        comment:  this.comment,
                    })
                })
                .then((data) => {
                    return data.json();
                })
                .then((data) => {
                    this.loading = false;
                    this.message = data.service.message;
                    this.success = data.success;
                    this.error = data.error;
                })

        },
    }
};
